import { render } from "./QueryTable.vue?vue&type=template&id=d3620a40&ts=true"
import script from "./QueryTable.vue?vue&type=script&lang=ts"
export * from "./QueryTable.vue?vue&type=script&lang=ts"

import "./QueryTable.vue?vue&type=style&index=0&id=d3620a40&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QSpace,QSelect,QInput,QDialog,QPage});
